import { render, staticRenderFns } from "./Plus.vue?vue&type=template&id=1f9a897e&scoped=true&"
import script from "./Plus.vue?vue&type=script&lang=js&"
export * from "./Plus.vue?vue&type=script&lang=js&"
import style0 from "./Plus.vue?vue&type=style&index=0&id=1f9a897e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a897e",
  null
  
)

component.options.__file = "Plus.vue"
export default component.exports